"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mockedPaymentResponseWithCount = exports.mockedPaymentResponseExceptFulfillmentShipments = exports.mockedPaymentResponse = exports.mockedPaymentUpdateStatusByPaymentRequest = exports.mockedPaymentCreateRequest = void 0;
const common_interfaces_1 = require("../../common-interfaces");
const date_util_1 = require("../../utils/date.util");
const omit_util_1 = require("../../utils/omit.util");
const cart_item_1 = require("../cart-item");
const payment_cart_item_1 = require("../payment-cart-item");
const payment_provider_1 = require("../payment-provider");
const refund_1 = require("../refund");
const fulfillment_shipment_1 = require("../fulfillment-shipment");
const dto_1 = require("../../dto");
exports.mockedPaymentCreateRequest = {
  currency: common_interfaces_1.Currency.dollar,
  invoiceId: 1,
  paymentProviderId: 1,
  paymentUrl: '',
  totalPrice: {
    total: 200,
    byProduct: [{
      price: 100,
      cartItemId: cart_item_1.mockedCartItemResponse.id,
      total: 200,
      quantity: 2
    }]
  },
  paymentId: 'qweasd123',
  paymentToken: 'token123456'
};
exports.mockedPaymentUpdateStatusByPaymentRequest = {
  paymentId: 'qweasd123',
  status: common_interfaces_1.PaymentStatus.COMPLETED
};
exports.mockedPaymentResponse = {
  id: 1,
  invoiceId: 1,
  currency: common_interfaces_1.Currency.dollar,
  paymentId: 'qweasd123',
  paymentToken: null,
  paymentProvider: payment_provider_1.mockedPaypalPaymentProvider,
  createdAt: date_util_1.takeDaysFromNow(),
  updatedAt: null,
  status: common_interfaces_1.PaymentStatus.COMPLETED,
  total: 100,
  shippingPrice: 20.5,
  cart: [payment_cart_item_1.mockedPaymentCartItem],
  refunds: [refund_1.mockedRefundResponseExceptPayment],
  fulfillmentShipments: [fulfillment_shipment_1.mockedFulfillmentShipmentResponse],
  files: [],
  paidAt: new Date(),
  mailStatus: dto_1.MailerStatus.SENT,
  oldId: null
};
exports.mockedPaymentResponseExceptFulfillmentShipments = omit_util_1.omitObject(exports.mockedPaymentResponse, 'fulfillmentShipments');
exports.mockedPaymentResponseWithCount = {
  items: [exports.mockedPaymentResponse],
  count: 1
};